import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface ICapacityTypeMeasurementAttributes extends IModelAttributes {
	capacityTypeId: string;
	measurementId: string;

	capacityType: Models.CapacityTypeEntity | Models.ICapacityTypeEntityAttributes;
	measurement: Models.MeasurementEntity | Models.IMeasurementEntityAttributes;
}

@entity('CapacityTypeMeasurement')
export default class CapacityTypeMeasurement extends Model implements ICapacityTypeMeasurementAttributes {
	@observable
	@attribute()
	public capacityTypeId: string;

	@observable
	@attribute()
	public measurementId: string;

	@observable
	@attribute({ isReference: true })
	public capacityType: Models.CapacityTypeEntity;

	@observable
	@attribute({ isReference: true })
	public measurement: Models.MeasurementEntity;

	constructor(attributes?: Partial<ICapacityTypeMeasurementAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.capacityTypeId) {
				this.capacityTypeId = attributes.capacityTypeId;
			}
			if (attributes.measurementId) {
				this.measurementId = attributes.measurementId;
			}

			if (attributes.capacityType) {
				if (attributes.capacityType instanceof Models.CapacityTypeEntity) {
					this.capacityType = attributes.capacityType;
					this.capacityTypeId = attributes.capacityType.id;
				} else {
					this.capacityType = new Models.CapacityTypeEntity(attributes.capacityType);
					this.capacityTypeId = this.capacityType.id;
				}
			} else if (attributes.capacityTypeId !== undefined) {
				this.capacityTypeId = attributes.capacityTypeId;
			}

			if (attributes.measurement) {
				if (attributes.measurement instanceof Models.MeasurementEntity) {
					this.measurement = attributes.measurement;
					this.measurementId = attributes.measurement.id;
				} else {
					this.measurement = new Models.MeasurementEntity(attributes.measurement);
					this.measurementId = this.measurement.id;
				}
			} else if (attributes.measurementId !== undefined) {
				this.measurementId = attributes.measurementId;
			}
		}
	}
}
